import './main.js';
import '../css/root.css';
import "./lazy-load.js";
import "./async-db.js";
import "./css-performance.js";
import "./performance-utils.js";
import './sidebar.js'
import './news-sidebar.js'
import './products.js'
import './suppliers-network.js'
import './suppliers-storytelling.js'
import './newsletter.js'
import './especiality.js'
import './blog-carousel.js'


(function () {
    console.log('Initializing hero video management...');
    function isVideoVisible(video) {
        if (!video) {
            return false;
        }

        var section = video.closest('.hero, .hero-mobile');

        if (!section) {
            return false;
        }

        var styles = window.getComputedStyle(section);

        return styles.display !== 'none' && styles.visibility !== 'hidden';
    }

    function playVideoWhenReady(video) {
        if (!video) {
            return;
        }

        video.preload = 'auto';
        video.autoplay = true;
        video.muted = true;
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');

        if (video.readyState >= 2) {
            video.play().catch(function () { });
            return;
        }

        if (video._heroLoadedDataHandler) {
            video.removeEventListener('loadeddata', video._heroLoadedDataHandler);
        }

        video._heroLoadedDataHandler = function () {
            video.play().catch(function () { });
            video._heroLoadedDataHandler = null;
        };

        video.addEventListener('loadeddata', video._heroLoadedDataHandler, {
            once: true
        });

        if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
            video.load();
        }
    }

    function resetInactiveVideo(video) {
        if (!video) {
            return;
        }

        video.pause();
        video.removeAttribute('autoplay');
        video.preload = 'metadata';

        if (video.readyState > 0) {
            try {
                video.currentTime = 0;
            } catch (error) { }
        }
    }

    function prioritizeHeroVideo() {
        var desktopVideo = document.querySelector('.hero-bg-video');
        var mobileVideo = document.querySelector('.hero-mobile-video');
        var primaryVideo = isVideoVisible(mobileVideo) ? mobileVideo : desktopVideo;
        var secondaryVideo = primaryVideo === mobileVideo ? desktopVideo : mobileVideo;

        resetInactiveVideo(secondaryVideo);
        playVideoWhenReady(primaryVideo);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', prioritizeHeroVideo);
    } else {
        prioritizeHeroVideo();
    }

    window.addEventListener('pageshow', prioritizeHeroVideo);
    window.addEventListener('resize', prioritizeHeroVideo);
})();